module.exports = __webpack_public_path__ + "img/demo-balou.73f3a208.png";